export const indexMenuLinks = [
  {
    name: 'Our Services',
    link: '/#services',
    icon: 'concierge-bell',
  },
  {
    name: 'Blog',
    link: '/#blog',
    icon: 'feather-alt',
  },
  {
    name: 'Contact',
    link: '/#contact',
    icon: 'envelope',
  },
  {
    name: 'Patient Forms',
    link: '/patientforms',
    icon: 'file-medical',
  },
];

export const blogMenuLinks = [
  {
    name: 'Home',
    link: '/',
    icon: 'home',
  },
  {
    name: 'Blog',
    link: '/blog',
    icon: 'feather-alt',
  },
  {
    name: 'Tags',
    link: '/tags',
    icon: 'tags',
  },
  {
    name: 'Patient Forms',
    link: '/patientforms',
    icon: 'file-medical',
  },
  {
    name: 'Privacy Practices',
    link: '/privacy',
    icon: 'user-secret',
  },
];
